import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import { TimeEntrySubTypeKey } from '@/modules/timeentry/constants/TimeEntrySubTypeKey';



export class TimeEntrySubType extends Enum {
  key!: TimeEntrySubTypeKey;
  value!: string;
  readonly?: boolean;

  static CEI_TRAINING_WORKSHOPS: TimeEntrySubType = {
    key: TimeEntrySubTypeKey.CEI_TRAINING_WORKSHOPS,
    get value(): string {
      return Lang.t('Training workshops');
    }
  };

  static CEI_INTERNAL_MEETINGS: TimeEntrySubType = {
    key: TimeEntrySubTypeKey.CEI_INTERNAL_MEETINGS,
    get value(): string {
      return Lang.t('Internal meetings');
    }
  };

  static CEI_RESEARCH: TimeEntrySubType = {
    key: TimeEntrySubTypeKey.CEI_RESEARCH,
    get value(): string {
      return Lang.t('Research');
    }
  };

  static CEI_PROCESS_IMPROVEMENT: TimeEntrySubType = {
    key: TimeEntrySubTypeKey.CEI_PROCESS_IMPROVEMENT,
    get value(): string {
      return Lang.t('Process improvement');
    }
  };

  static CEI_WORKING_WITH_SALES: TimeEntrySubType = {
    key: TimeEntrySubTypeKey.CEI_WORKING_WITH_SALES,
    get value(): string {
      return Lang.t('timetracking.working-with-sales');
    }
  };

  static CEI_ADMIN_TASKS_JEPS: TimeEntrySubType = {
    key: TimeEntrySubTypeKey.CEI_ADMIN_TASKS_JEPS,
    get value(): string {
      return Lang.t('Admin tasks JEPS');
    }
  };

  static CEI_WORKING_WITH_PRODUCT: TimeEntrySubType = {
    key: TimeEntrySubTypeKey.CEI_WORKING_WITH_PRODUCT,
    get value(): string {
      return Lang.t('Working with product');
    }
  };

  static CEI_WORKING_WITH_FINANCE: TimeEntrySubType = {
    key: TimeEntrySubTypeKey.CEI_WORKING_WITH_FINANCE,
    get value(): string {
      return Lang.t('timetracking.working-with-finance');
    }
  };

  static CEI_WORKING_WITH_PARTNERS: TimeEntrySubType = {
    key: TimeEntrySubTypeKey.CEI_WORKING_WITH_PARTNERS,
    get value(): string {
      return Lang.t('timetracking.working-with-partners');
    }
  };

  static CEI_PLATFORM_NOTIFICATIONS: TimeEntrySubType = {
    key: TimeEntrySubTypeKey.CEI_PLATFORM_NOTIFICATIONS,
    get value(): string {
      return Lang.t('timetracking.platform-notifications');
    }
  };

  static CEI_IT_ISSUES: TimeEntrySubType = {
    key: TimeEntrySubTypeKey.CEI_IT_ISSUES,
    get value(): string {
      return Lang.t('IT issues');
    }
  };

  static CEI_MISCELLANEOUS: TimeEntrySubType = {
    key: TimeEntrySubTypeKey.CEI_MISCELLANEOUS,
    get value(): string {
      return Lang.t('Miscellaneous');
    },
    readonly: true
  };
}
